// Angular Modules
import { inject, Injectable, PLATFORM_ID } from "@angular/core"
import { injectStripe, StripeServiceInterface } from "ngx-stripe"
import { isPlatformBrowser } from "@angular/common"

@Injectable({ providedIn: "root" })
export class StripeService {
    private platformId = inject(PLATFORM_ID)
    public stripe: StripeServiceInterface = null

    constructor() {
        if (isPlatformBrowser(this.platformId)) {
            this.stripe = injectStripe()
        }
    }
}
